import {Image, Text, View} from '@react-pdf/renderer';
import React from 'react';
import {styles} from './styles';
import sleipnerLogo from 'assets/logo.png';

export const Footer = ({showellUser, backgroundUrl, backgroundHeight}) => {
	const {name, email, mobile} = showellUser;

	return (
		<>
			{backgroundUrl && (
				<Image
					src={backgroundUrl}
					style={[
						styles.image.pageBackground,
						{bottom: 0, left: 0, right: 0, height: backgroundHeight ?? 100},
					]}
				/>
			)}
			<View
				style={[
					styles.layout.container,
					{
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'space-between',
						alignItems: 'flex-end',
						width: '100%',
						position: 'absolute',
						bottom: -15,
					},
				]}
			>
				<View
					style={[
						styles.text.yellow,
						{display: 'flex', flexDirection: 'row', width: '33%'},
					]}
				>
					<Image src={sleipnerLogo} style={styles.image.sleipnerFooterLogo} />
					<Text
						style={{fontWeight: 600, position: 'relative', top: '33px', left: '10px'}}
					>
						Wheels of change.
					</Text>
				</View>
				<View
					style={[
						styles.text.white,
						{
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'center',
							width: '33%',
							position: 'relative',
							left: '5px',
						},
					]}
				>
					<Text style={[styles.text.yellow, {fontWeight: 'bold'}]}>
						SLEIPNER FINLAND OY
					</Text>
					{/* <Text>{name}</Text>
					<Text style={{marginTop: '-4px'}}>{mobile}</Text>
					<Text style={{marginTop: '-4px'}}>{email}</Text> */}
				</View>
				<View
					style={[
						styles.text.white,
						{
							display: 'flex',
							flexDirection: 'column',
							alignItems: 'flex-end',
							justifyContent: 'center',
							width: '33%',
							paddingRight: '20px',
						},
					]}
				>
					<Text style={[styles.text.yellow, {fontWeight: 'bold'}]}>sleipner.com</Text>
				</View>
			</View>
		</>
	);
};
